module.exports = __webpack_public_path__ + "img/FR12098.1d859996.png";